import React from 'react';
import { useSettings } from '../../../hooks/admin/useSettings';
import { SettingsCard } from './SettingsCard';

export function SecuritySettings() {
  const { settings, updateSettings, isLoading } = useSettings('security');

  return (
    <SettingsCard
      title="Security Settings"
      description="Configure security and authentication settings"
      isLoading={isLoading}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Minimum Password Length
          </label>
          <input
            type="number"
            min="8"
            max="32"
            value={settings?.minPasswordLength || 8}
            onChange={(e) => updateSettings({ minPasswordLength: parseInt(e.target.value) })}
            className="input w-full"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Session Timeout (minutes)
          </label>
          <input
            type="number"
            min="5"
            value={settings?.sessionTimeout || 60}
            onChange={(e) => updateSettings({ sessionTimeout: parseInt(e.target.value) })}
            className="input w-full"
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="require-2fa"
              checked={settings?.require2FA || false}
              onChange={(e) => updateSettings({ require2FA: e.target.checked })}
              className="rounded border-gray-700 text-accent-green focus:ring-accent-green bg-background-dark"
            />
            <label htmlFor="require-2fa" className="ml-2 text-sm text-white">
              Require Two-Factor Authentication
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="allow-social-login"
              checked={settings?.allowSocialLogin || false}
              onChange={(e) => updateSettings({ allowSocialLogin: e.target.checked })}
              className="rounded border-gray-700 text-accent-green focus:ring-accent-green bg-background-dark"
            />
            <label htmlFor="allow-social-login" className="ml-2 text-sm text-white">
              Allow Social Login
            </label>
          </div>
        </div>
      </div>
    </SettingsCard>
  );
}